import { VhsIcon } from './VhsIcon';

/**
 * author: GreenTurtwig
 * id 551637A8-2091-4439-9710-71199B7AC0C1
 * name vhs
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vhs.svg
 * tags
 * - Video / Movie 
 */
export const VideoHomeSystemIcon = VhsIcon;
export default VideoHomeSystemIcon